<script>
    import page from 'page';
    import { publicStore, admin as adminStore, login as loginStore} from 'src/stores.js';

    let locationUrl = new URL(window.location);
    $adminStore.split  = locationUrl.searchParams.has('split');

    $: {
        $adminStore.legacy = locationUrl.searchParams.has('legacy');
        if ($adminStore.legacy) {
            $adminStore.readonly = true;
        } else {
            if ($loginStore && $loginStore.user) {
                $adminStore.readonly = !(['ADMIN'].includes($loginStore.user.role_name));
            }
        }
    }

    import { bind as bindComponent } from 'svelte-simple-modal';
    import Modal from 'src/components/Modal/Modal.svelte';

    // set default component
//    let current = Public;
    let current;
    let currentName;

    // Map routes to page. If a route is hit the current
    // reference is set to the route's component

    page('/blt/public/*', async function (ctx) {
        let path = ctx.pathname.replace(/\/blt\/public\//,'');
        //get rid of trailing slash
        path = path.replace(/\/$/,'');
        $publicStore.path = path;
        //Don't want to keep binding base admin component everytime they click client side admin route
        //Just want to change the path and reload individual admin page/screen
        if (currentName !== 'public') {
            let Public = await import('src/pages/public/Index.svelte');
            current = Public.default;
// before was using a path property on base admin comnponent and had to use bindComponent
// now don't have to use that since setting path in store so we don't have to rebind compnent on every admin path change
//            current = bindComponent(Admin.default,{path});
        }
        currentName = 'public';
    });

    //add these redirects for vite de server. IIS already does the redirect
    page.redirect('/blt/public', '/blt/public/');

    page('/blt/help/*', async function (ctx) {
        let path = ctx.pathname.replace(/\/blt\/help\//,'').replace(/\/$/,'');
        let Help = await import('src/pages/help/Index.svelte');
        current = bindComponent(Help.default,{page:path});

        currentName = 'help';
    });
    page.redirect('/blt/help', '/blt/help/');

    page('/blt/admin/*', async function (ctx) {
//        console.log(ctx);
        let path = ctx.pathname.replace(/\/blt\/admin\//,'');
        //get rid of trailing slash
        path = path.replace(/\/$/,'');
        $adminStore.path = path;
        //Don't want to keep binding base admin component everytime they click client side admin route
        //Just want to change the path and reload individual admin page/screen
        if (currentName !== 'admin') {
            let Admin = await import('src/pages/admin/Index.svelte');
            current = Admin.default;
// before was using a path property on base admin comnponent and had to use bindComponent
// now don't have to use that since setting path in store so we don't have to rebind compnent on every admin path change
//            current = bindComponent(Admin.default,{path});
        }
        currentName = 'admin';
    });
    page.redirect('/blt/admin', '/blt/admin/');

    // activate router
    page.start();

</script>
<style>
</style>

<!--
<a href='/blt/public/'>public test</a>
<a href='/blt/help/public/'>help test</a>
<a href='/blt/admin/'>admin test</a>
-->

<svelte:component this={current} />

<!-- need a modal for each level of simultaneous modals we want to show on top of each other -->
<Modal options={{styleWindow:{width:"90%"}}} />
<Modal name='secondary' options={{styleWindow:{width:"90%"}}} />
<Modal name='tertiary' options={{styleWindow:{width:"90%"}}} />
<Modal name='loading' />

